export default __webpack_public_path__ + "static/media/gwn_main.a8fcb61c.webp";